<template>
  <div>
    <div class="booking-box-select">
      <div class="box-st-select">
        <div class="booking-total-sticky">
          <div class="total-price">
            <div class="left">ราคารวมทั้งหมด</div>
            <div class="right">{{ totalBookingPriceText }}</div>
          </div>
          <div class="text-right">
            <sc-button
              variant="orange-cc"
              style="height: 100%"
              @click="handleSubmitBooking"
              >ยืนยันการจอง</sc-button
            >
          </div>
        </div>
      </div>
      <div class="text-left mb-4 mt">
        <div class="mb-3 booking-title-detail">รายละเอียดการจอง</div>
        <div class="row booking-row">
          <div class="col-xl-5 col-lg-5 col-md-12 col-sm-12 col-12 date-range">
            <span>ช่วงวันที่</span>
            <div>
              <el-date-picker
                class="el-full"
                v-model="roomDateRangeSelect"
                type="dates"
                format="dd-MM-yyyy"
              ></el-date-picker>
            </div>
          </div>
          <div
            class="
              col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12
              padding
              booking-show-button
            "
          >
            <button
              class="btn sc-btn-outline"
              @click="handleClickShowConferenceDetail"
            >
              แสดงรายละเอียดการจอง
            </button>
          </div>
          <!-- <div
            class="
              col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12
              padding
              duplicate-check-box
            "
          >
            <el-checkbox label="เลือกให้ใส่รายละเอียดเหมือนกัน"></el-checkbox>
          </div> -->
        </div>
        <div>
          <div
            v-for="(
              conferenceDetailSelectedDate, conferenceDetailIndex
            ) in conferenceDetailsByDateSelected"
            :key="conferenceDetailIndex"
            class="conference-detail"
          >
            <button
              @click="
                handleChangeInput(
                  !conferenceDetailSelectedDate.isShow,
                  'isShow',
                  conferenceDetailSelectedDate.dateSelect
                )
              "
              class="button-toggle"
            >
              <div class="header-booking-detail mb-2">
                <div class="date-selected">
                  {{ conferenceDetailSelectedDate.dateSelect }}
                </div>
                <div class="arrow-detail"></div>
              </div>
              <div>
                <img
                  v-if="!conferenceDetailSelectedDate.isShow"
                  :src="'/static/icons/arrow-down-orange.svg'"
                  class="book-icon arrow"
                />
                <img
                  v-if="conferenceDetailSelectedDate.isShow"
                  :src="'/static/icons/arrow-up-orange.svg'"
                  class="book-icon arrow"
                />
              </div>
            </button>
            <slide-up-down
              class="AccordionWrapper"
              :active="conferenceDetailSelectedDate.isShow"
            >
              <div class="row conference-input-select mb-3">
                <div
                  class="
                    col-selected col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12
                  "
                >
                  <span>ช่วงเวลา</span>
                  <div>
                    <el-select
                      :value="conferenceDetailSelectedDate.timeDuration"
                      clearable
                      style="width: 100%"
                      @input="
                        handleChangeInput(
                          $event,
                          'timeDuration',
                          conferenceDetailSelectedDate.dateSelect
                        )
                      "
                    >
                      <el-option
                        v-for="p in conferenceDetailSelectedDate.timeDurationDropdownList"
                        :value="p.value"
                        :label="p.label"
                        :key="p.code"
                        >{{ p.label }}</el-option
                      >
                    </el-select>
                  </div>
                </div>
                <div
                  class="
                    col-selected col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12
                  "
                >
                  <span>ลักษณะการจัดห้อง</span>
                  <div>
                    <el-select
                      :value="conferenceDetailSelectedDate.conferencePattern"
                      clearable
                      style="width: 100%"
                      @input="
                        handleChangeInput(
                          $event,
                          'conferencePattern',
                          conferenceDetailSelectedDate.dateSelect
                        )
                      "
                    >
                      <el-option
                        v-for="p in conferenceDetailSelectedDate.patternDropdownList"
                        :value="p.label"
                        :label="p.label"
                        :key="p.id"
                        class="option-format"
                        ><img :src="p.icon" alt="" /> &nbsp;&nbsp;&nbsp;
                        {{ p.label }}</el-option
                      >
                    </el-select>
                  </div>
                </div>
                <div
                  class="col-selected col-xl-1 col-lg-1 col-md-6 col-sm-6 col-6"
                >
                  <span>จำนวน (ท่าน)</span>
                  <el-input
                    class="el-full"
                    :value="conferenceDetailSelectedDate.people"
                    @input="
                      handleChangeInput(
                        $event,
                        'people',
                        conferenceDetailSelectedDate.dateSelect
                      )
                    "
                  ></el-input>
                </div>
                <div
                  class="
                    only-conference
                    col-xl-2 col-lg-2 col-md-6 col-sm-6 col-6
                  "
                >
                  <el-checkbox
                    :value="conferenceDetailSelectedDate.isSelectOnlyRoom"
                    @change="
                      handleChangeInput(
                        $event,
                        'isSelectOnlyRoom',
                        conferenceDetailSelectedDate.dateSelect
                      )
                    "
                    >ห้องอย่างเดียว</el-checkbox
                  >
                </div>
                <div
                  class="
                    price-desktop
                    col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12
                    mt-3
                  "
                >
                  <div class="conference-price">
                    <div><span class="padding-8">ราคารวม</span></div>
                    <div>{{ conferenceDetailSelectedDate.priceText }}</div>
                  </div>
                  <div>
                    <span class="padding-8"
                      >ราคาห้อง:
                      {{ conferenceDetailSelectedDate.pricePerRoomText }}</span
                    >
                  </div>
                  <div>
                    <span class="padding-8"
                      >ราคาต่อหัว:
                      {{
                        conferenceDetailSelectedDate.conferencePricePackagePerUnitText
                      }}</span
                    >
                  </div>
                  <div>
                    <span class="padding-8"
                      >ราคาต่อหัวรวม:
                      {{
                        conferenceDetailSelectedDate.totalPriceByPeopleText
                      }}</span
                    >
                  </div>
                </div>
              </div>
              <div
                class="option-box"
                v-if="!conferenceDetailSelectedDate.isSelectOnlyRoom"
              >
                <div>เลือกลักษณะ break</div>
                <div class="row option-row">
                  <div
                    v-for="(
                      conferenceOption, conferenceOptionIndex
                    ) in conferenceDetailSelectedDate.breakPackages"
                    :key="conferenceOptionIndex"
                    class="
                      col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12
                      mb-2
                      option-box-padding
                    "
                  >
                    <div class="option-type-select option-border" v-if="conferenceOption.isShow">
                      <div class="option-type-name">
                        <div>
                          <input
                            type="radio"
                            :value="conferenceOption.isSelect"
                            :name="conferenceDetailIndex"
                            class="radio-option"
                            @input="
                              handleChangeInput(
                                true,
                                'conferenceOptionBreak',
                                conferenceDetailSelectedDate.dateSelect,
                                conferenceOption.id
                              )
                            "
                          />
                        </div>
                        <div class="conference-option-name">
                          <div class="bold-detail">
                            {{ conferenceOption.title }}
                          </div>
                          <div class="break-img">
                            <div
                              v-if="conferenceOption.breaks"
                              class="reserve-input-box"
                            >
                              <div
                                v-for="(
                                  breakOption, breakIndex
                                ) in conferenceOption.breaks"
                                :key="breakIndex"
                                class="coffee-icon"
                              >
                                <img
                                  src="/static/icons/coffee-cup-icon.svg"
                                  alt=""
                                  style="width: 30px"
                                />
                              </div>
                            </div>
                            <div
                              v-if="conferenceOption.lunch"
                              class="coffee-icon"
                            >
                              <img
                                src="/static/icons/cutlery-icon.svg"
                                style="width: 20px"
                                alt=""
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="option-price">
                        <div
                          v-for="(
                            breakOption, ratePerPeopleIndex
                          ) in conferenceOption.priceOptions"
                          :key="ratePerPeopleIndex"
                          class="person-line"
                        >
                          <div class="option-person">
                            <div class="bold-detail">
                              {{ breakOption.durationAttendeeTitle }}
                              <div class="per-person">persons</div>
                            </div>
                            <div class="bold-detail per-price">
                              ฿{{ breakOption.pricePerPerson }}
                              <div class="per-person">/person</div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-if="conferenceOption.isSelect" class="row">
                        <div
                          v-for="(
                            breakTime, breakTimeIndex
                          ) in conferenceOption.breaks"
                          :key="breakTimeIndex"
                          class="col-6 col-selected"
                        >
                          <div class="mb-3">
                            <span>
                              Coffee break ({{ breakTimeIndex + 1 }})</span
                            >
                            <el-time-select
                              :value="breakTime.time"
                              :picker-options="{
                                start: '08:00',
                                step: '01:00',
                                end: '17:00',
                              }"
                              placeholder="Select time"
                              @input="
                                handleChangeInput(
                                  $event,
                                  'time',
                                  conferenceDetailSelectedDate.dateSelect,
                                  conferenceOption.id,
                                  breakTime.id
                                )
                              "
                              :editable="false"
                            />
                          </div>
                        </div>
                        <div
                          v-if="conferenceOption.lunch"
                          class="col-12 col-selected"
                        >
                          <span
                            >อาหารเที่ยงตอน
                            <span class="time-span">{{
                              conferenceOption.lunch
                            }}</span>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="price-mobile">
                <div class="conference-price">
                    <div><span class="padding-8">ราคารวม</span></div>
                    <div>{{ conferenceDetailSelectedDate.priceText }}</div>
                  </div>
                <div>
                  <span class="padding-8"
                    >ราคาห้อง:
                    {{ conferenceDetailSelectedDate.pricePerRoomText }}</span
                  >
                </div>
                <div>
                  <span class="padding-8"
                    >ราคาต่อหัว:
                    {{
                      conferenceDetailSelectedDate.conferencePricePackagePerUnitText
                    }}</span
                  >
                </div>
                <div>
                  <span class="padding-8"
                    >ราคาต่อหัวรวม:
                    {{
                      conferenceDetailSelectedDate.totalPriceByPeopleText
                    }}</span
                  >
                </div>
              </div>
            </slide-up-down>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ScButton from "@/lib/components/ScButton";
import {
  DatePicker,
  Input,
  Option,
  Select,
  Checkbox,
  TimeSelect,
} from "element-ui";
import { DateTime } from "luxon";
import SlideUpDown from "vue-slide-up-down";
import {
  timeDurationDropdown,
  conferencePatternDropdown,
} from "../VariableStatic";
import { getUniqArrayObject, checkExistEveryValueInObject } from "@/lib/util";
import {
  convertPriceStringToNumber,
  formatCurrencyBath
} from "@/lib/formatter";
import { timeDuration } from "@/lib/mapper";

export default {
  components: {
    "sc-button": ScButton,
    "el-date-picker": DatePicker,
    "el-checkbox": Checkbox,
    "el-input": Input,
    "el-option": Option,
    "el-select": Select,
    "el-time-select": TimeSelect,
    "slide-up-down": SlideUpDown,
  },
  props: ["conferenceDetail"],
  computed: {
    totalBookingPriceText() {
      return this.totalBookingPrice
        ? formatCurrencyBath(this.totalBookingPrice)
        : null;
    }
  },
  data() {
    return {
      roomDateRangeSelect: [],
      conferenceDetailsByDateSelected: [],
      totalBookingPrice: 0
    };
  },
  watch: {
  },
  methods: {
    handleClickShowConferenceDetail() {
      if (!this.roomDateRangeSelect || this.roomDateRangeSelect.length === 0) {
        this.conferenceDetailsByDateSelected = [];
      }

      this.roomDateRangeSelect = this.roomDateRangeSelect.sort((a, b) => a - b);

      const datesSelect = this.roomDateRangeSelect.map((select) => {
        const dateSelect = DateTime.fromJSDate(select).toFormat("dd-MM-yyyy");

        const conferencesEditedByDate =
          this.conferenceDetailsByDateSelected.find(
            (conference) => conference.dateSelect === dateSelect
          );

        if (conferencesEditedByDate) {
          return conferencesEditedByDate;
        }

        const timeDropdown = getUniqArrayObject(
          this.conferenceDetail.priceOption,
          "timeDuration"
        );

        const timeDurationDropdownList = timeDurationDropdown.filter((time) =>
          timeDropdown.includes(time.value)
        );

        const patternDropdown = getUniqArrayObject(
          this.conferenceDetail.priceOption,
          "pattern"
        );

        const patternDropdownList = conferencePatternDropdown.filter(
          (pattern) => patternDropdown.includes(pattern.label)
        );

        const breakPackages = this.conferenceDetail.breakPackages
          && this.conferenceDetail.breakPackages.length > 0
            ? this.conferenceDetail.breakPackages.sort((a, b) => 
              (a.breaks.length + (a.lunch ? 1 : 0 )) - (b.breaks.length + (b.lunch ? 1 : 0 ))
            )
            : null;

        return {
          dateSelect,
          conferencePattern: null,
          people: null,
          price: 0,
          breakPackages: breakPackages,
          isShow: true,
          timeDurationDropdownList,
          patternDropdownList,
          isSelectOnlyRoom: false,
          conferencePricePackagePerUnit: null,
        };
      });

      this.conferenceDetailsByDateSelected = datesSelect;
    },
    handleChangeInput(value, key, dateSelect, optionId, breakTimeId) {
      const conferenceDetailChanging = this.conferenceDetailsByDateSelected.map(
        (conferDetail) => {
          if (dateSelect !== conferDetail.dateSelect) {
            return {
              ...conferDetail
            };
          };

          const timeDurationChanging = key === "timeDuration"
            ? value
            : conferDetail.timeDuration;

          const isFullDaySpecial = timeDurationChanging === timeDuration.FULL_DAY_SPECIAL;

          const isSelectOnlyRoomAction =
            (
              conferDetail.isSelectOnlyRoom === true &&
              key !== "isSelectOnlyRoom"
            ) || (key === "isSelectOnlyRoom" && value === true)
            || isFullDaySpecial;

          const timeDurationByType = timeDurationDropdown.find((time) =>
            timeDurationChanging.includes(time.value)
          );

          const breaksByType = conferDetail.breakPackages
            && conferDetail.breakPackages.length > 0
            && timeDurationByType
            ? conferDetail.breakPackages.map(
              (breakPack) => {
                let isShow = breakPack.isShow
                let isSelect = breakPack.isSelect
                if (timeDurationChanging === timeDuration.FULL_DAY_SPECIAL) {
                  isShow = false
                  isSelect = false
                } else {
                  isShow = breakPack.typePackage === timeDurationByType.type
                    || timeDurationChanging === timeDuration.FULL_DAY_SPECIAL
                }

                if (
                  key === "timeDuration"
                  && breakPack.typePackage !== timeDurationByType.type
                ) {
                  isSelect = false
                }
                
                return {
                  ...breakPack,
                  isShow,
                  isSelect
                }
              }
            )
            : conferDetail.breakPackages

          // เปลี่ยน break option ตามที่เลือกมา
          const breakPackages = breaksByType && breaksByType.map((option) => {
            const breaks = option.breaks.map((breakOp) => {
              const time =
                key === "time" &&
                conferDetail.dateSelect === dateSelect &&
                option.id === optionId &&
                breakOp.id === breakTimeId
                  ? value
                  : breakOp.time;

              return {
                ...breakOp,
                time,
              };
            });

            let isSelect = option.isSelect;
            if (isSelectOnlyRoomAction) {
              isSelect = false
            } else if (
              key === "conferenceOptionBreak" &&
              conferDetail.dateSelect === dateSelect
            ) {
              isSelect = option.id === optionId;
            }

            return {
              ...option,
              breaks,
              isSelect,
            };
          });

          const isBreakOptionSelect = breakPackages && breakPackages.some(
            (breakPack) => breakPack.isSelect === true
          )

          // filter ลักษระห้อง ตามวันที่เลือก
          let patternDropdownList;
          if (key === "timeDuration" && !conferDetail.conferencePattern) {
            const priceOptionFilterByTimeDuration =
              this.conferenceDetail.priceOption.filter(
                (option) => option.timeDuration === value
              );

            const patternDropdown = getUniqArrayObject(
              priceOptionFilterByTimeDuration,
              "pattern"
            );

            const patternList = conferencePatternDropdown.filter((pattern) =>
              patternDropdown.includes(pattern.label)
            );

            patternDropdownList = patternList;
          } else {
            patternDropdownList = conferDetail.patternDropdownList;
          }

          let conferencePatternChanging
          if (
            isSelectOnlyRoomAction
            || this.conferenceDetail.priceOption.every(
              (priceOp) => priceOp.label === "Room Only"
            )
          ) {
            conferencePatternChanging = "Room Only";
          } else if (key === "conferencePattern") {
            conferencePatternChanging = value
          } else {
            conferencePatternChanging = conferDetail.conferencePattern;
          }

          const conferPriceByPatternAndDuration = this.conferenceDetail.priceOption.find(
            (op) =>
              op.pattern === conferencePatternChanging &&
              op.timeDuration === timeDurationChanging
          );

          const breakOptionSelect = breakPackages.find(
            (breakPack) => breakPack.isSelect === true
          )

          const conferencePriceByPatternAndDuration =
            conferPriceByPatternAndDuration &&
            conferPriceByPatternAndDuration.price &&
            parseFloat(conferPriceByPatternAndDuration.price) > 0 &&
            !breakOptionSelect
              ? conferPriceByPatternAndDuration.price
              : null;

          let pricePerRoom = convertPriceStringToNumber(
            conferencePriceByPatternAndDuration
          );

          let totalPrice = conferDetail.price;
          let totalPriceByPeople = conferDetail.totalPriceByPeople
            ? conferDetail.totalPriceByPeople
            : null;

          const people = key === "people" ? value : conferDetail.people;

          let conferencePricePackagePerUnit = conferDetail.conferencePricePackagePerUnit;
          if (isSelectOnlyRoomAction) {
            conferencePricePackagePerUnit = 0;
          } else {
            conferencePricePackagePerUnit = null;
          }

          if (breakOptionSelect) {
            const priceOptionDurationSelect = breakOptionSelect.priceOptions.filter(
              (op) => (
                op.fromAttendeeCount <= people && op.toAttendeeCount >= people
              ) || (
                op.fromAttendeeCount <= people && !op.toAttendeeCount
              ) || (
                op.toAttendeeCount >= people && !op.fromAttendeeCount
              )
            )

            let priceOptionSelect
            if (priceOptionDurationSelect && priceOptionDurationSelect.length > 0) {
              priceOptionSelect = priceOptionDurationSelect.reduce(
                (a, b) => (
                  convertPriceStringToNumber(a.pricePerPerson)
                  < convertPriceStringToNumber(b.pricePerPerson)
                    ? a : b
                )
              )
            } else {
              priceOptionSelect = breakOptionSelect.priceOptions.reduce(
                (a, b) => (
                  convertPriceStringToNumber(a.pricePerPerson)
                  > convertPriceStringToNumber(b.pricePerPerson)
                    ? a : b
                )
              )
            }

            if (!priceOptionSelect || !priceOptionSelect.pricePerPerson) {
              alert('ไม่สามารถเลือก break นี้ได้');
              return {
                ...conferDetail,
                breakPackages: this.conferenceDetail.breakPackages
              }
            }

            const pricePerUnit = convertPriceStringToNumber(
              priceOptionSelect.pricePerPerson
            );

            const peopleSelect = (people || 0) * (pricePerUnit || 0);
            console.log(conferencePriceByPatternAndDuration);
            console.log(peopleSelect);
            totalPriceByPeople = peopleSelect;
            totalPrice = peopleSelect + convertPriceStringToNumber(
              conferencePriceByPatternAndDuration
            );
            conferencePricePackagePerUnit = `${formatCurrencyBath(
              pricePerUnit)}/ท่าน`
          } else if (isSelectOnlyRoomAction) {
            totalPriceByPeople = 0;
            totalPrice = convertPriceStringToNumber(
              conferencePriceByPatternAndDuration
            );
            conferencePricePackagePerUnit = `${formatCurrencyBath(0)}/ท่าน`
          } else {
            totalPriceByPeople = null;
            totalPrice = null;
          }

          const conferencePricePackagePerUnitText = isBreakOptionSelect
            ? `${conferencePricePackagePerUnit} x ${people} ท่าน`
            : '-';

          const totalPriceByPeopleText = isBreakOptionSelect
            ? formatCurrencyBath(totalPriceByPeople)
            : '-'

          const pricePerRoomText = !isSelectOnlyRoomAction
            ? '-'
            : formatCurrencyBath(pricePerRoom);

          return {
            ...conferDetail,
            breakPackages,
            [key]:
              conferDetail.dateSelect === dateSelect &&
              (key === "timeDuration" ||
                "conferencePattern" ||
                "people" ||
                "isShow")
                ? value
                : conferDetail[key],
            patternDropdownList,
            price: totalPrice,
            pricePerRoom,
            totalPriceByPeople,
            priceText: formatCurrencyBath(totalPrice),
            pricePerRoomText,
            totalPriceByPeopleText,
            conferencePricePackagePerUnit,
            conferencePricePackagePerUnitText,
            isSelectOnlyRoom: isSelectOnlyRoomAction
          };
        }
      );

      this.totalBookingPrice = conferenceDetailChanging.reduce(
        (a, b) => (a || 0) + (b.price || 0), 0
      );

      this.conferenceDetailsByDateSelected = conferenceDetailChanging;
    },
    handleSubmitBooking() {
      if (
        !this.conferenceDetailsByDateSelected
        || this.conferenceDetailsByDateSelected.length === 0
      ) {
        alert('การบันทึกข้อมูลเกิดความผิดพลาด');
        return
      }

      const bookingDateList = this.conferenceDetailsByDateSelected.map(
        (dateSelect) => {
          const breakOption = dateSelect.breakPackages
            && dateSelect.breakPackages.length > 0
            ? dateSelect.breakPackages.find(
              (breakPackage) => breakPackage.isSelect === true
            )
            : null;

          const break_option = breakOption
            ? {
              package_id: breakOption.id,
              package_title: breakOption.title,
              lunch: breakOption.lunch || null,
              break_time: breakOption.breaks.map((breakTime) => breakTime.time)
            }
            : null;

          return {
            date: dateSelect.dateSelect,
            time_duration: dateSelect.timeDuration,
            number_of_people: dateSelect.people,
            pattern: dateSelect.conferencePattern,
            price: dateSelect.price,
            break_option
          }
        }
      );

      const dateListForCheckValid = bookingDateList.map((bookingDate) => {
        return {
          ...bookingDate,
          break_option: 'can invalid'
        }
      })

      const checkvalue = dateListForCheckValid.every(
        (dateCheck) => checkExistEveryValueInObject(dateCheck)
      )

      if (!checkvalue) {
        alert('กรุณากรอกข้อมูลให้ครบถ้วน');
        return
      }

      if (
        !this.conferenceDetail
        || !this.totalBookingPrice
      ) {
        alert('การบันทึกข้อมูลเกิดความผิดพลาด');
        return
      }

      const paramBookings = {
        room_type_id: this.conferenceDetail.conferenceId,
        room_title: this.conferenceDetail.title,
        total_price: this.totalBookingPrice,
        booking_date_list: bookingDateList,
        images: this.conferenceDetail.images
      }

      const { conferenceId } = this.$route.params;

      this.$router.push({
        name: "BookingConfirm",
        params: {
          conferenceId,
          paramBookings
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../css/otherWebVariables";

.booking-box-select {
  position: relative;
}

.booking-total-sticky {
  display: grid;
  grid-template-columns: 80% auto;
  width: 100%;
  grid-gap: 15px;
  position: -webkit-sticky;
  top: 0;
  z-index: 99;
  padding-bottom: 8px;
  padding-top: 8px;
}

.total-price {
  background-color: $color-light-orange;
  padding-left: 10px;
  padding-right: 10px;
  justify-content: space-between;
  display: flex;
  color: $color-orange;

  .left {
    margin: auto;
    margin-left: 10px;
    font-size: $font-14;
  }

  .right {
    margin: auto;
    margin-right: 10px;
    font-weight: bold;
    font-size: $font-18;
  }
}

.text-right {
  text-align: right;
}

.text-left {
  text-align: left;
}

.sc-button {
  font-size: $font-14;
  width: 100%;
}

.reserve-input-box {
  display: flex;
}

.coffee-icon {
  display: flex;
  padding-left: 10px;
}

.duplicate-check-box {
  width: 63%;
  text-align: right;
}

.padding {
  padding-top: 25px;
}

.sc-btn-outline {
  border-radius: 5px;
  height: 40px;
  width: 100%;
  height: inherit;
}

.booking-title-detail {
  font-size: 20px;
  color: $color-orange;
}

.date-range {
  width: 50%;
}

.el-full {
  width: 100%;
}

.break-img {
  padding-top: 10px;
  display: flex;
}

.sc-button {
  padding: 8px 10px;
  font-size: $font-16;
  width: 100%;
}

.conference-detail {
  height: auto;
  border: 1px solid $color-light-gray-1;
  border-top: 5px solid $color-orange;
  border-radius: 5px;
  margin-top: 25px;
  padding: 15px;
}

span {
  font-size: $font-14;
}

.conference-input-select {
  height: 100%;
}

.el-full {
  height: 100%;
}

.only-conference {
  padding-top: 30px;
  padding-right: 0;
  padding-left: 25px;
}

.conference-price {
  background-color: $color-light-orange-2;
  height: 40px;
  border-radius: 5px;
  padding-right: 15px;
  padding-top: 5px;
  font-weight: bold;
  font-size: $font-18;
  color: $color-orange;
  justify-content: space-between;
  display: flex;
}

.date-selected {
  font-size: 24px;
  font-weight: bold;
  color: $color-orange;
  border-radius: 5px;
}

.option-row {
  padding: 15px;
  padding-top: 5px;
}

.option-type-select {
  height: inherit;
  display: grid;
  grid-template-columns: 60% 40%;
  padding: 15px;
  padding-left: 15px;
}

.option-border {
  border: 1px solid $color-light-gray-1;
  border-radius: 5px;
}

.option-box-padding {
  padding-right: 5px;
  padding-left: 5px;
}

.option-type-name {
  display: flex;
}

.option-price {
  padding: 15px;
}

.person-line {
  border-left: 1px solid $color-light-gray-1;
  padding-left: 20px;
}

.option-person {
  display: grid;
  grid-template-columns: 50% 50%;
  padding-bottom: 15px;
}

.bold-detail {
  font-weight: bold;
}

.per-person {
  font-weight: bold;
  font-size: $font-12;
}

.per-price {
  color: $color-orange;
  text-align: right;
}

.option-format {
  padding-top: 8px;
  padding-bottom: 8px;
  height: inherit;
  border-bottom: 0.5px solid $light-gray-2;
}

.option-format:last-child {
  border-bottom: 0;
}

input[type="radio"] {
  transform: scale(1.5);
}

.conference-option-name {
  display: inline;
  padding-left: 15px;
}

.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100%;
}

.button-toggle {
  width: 100%;
  border: 0;
  cursor: pointer;
  text-align: left;
  display: flex;
  justify-content: space-between;
  background-color: $white;
}

.arrow {
  margin: auto;
  margin-top: 50%;
  width: 20px;
}

.time-span {
  color: $color-orange;
}

.price-mobile {
  display: none;
}

.padding-8 {
  padding-left: 8px;
}

@media screen and (min-width: $ml-size) {
  .box-st-select {
    height: 100%;
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: $white;
  }

  .col-selected {
    padding-right: 0;
  }

  .price-desktop {
    padding-left: 0;
  }

  .booking-show-button {
    padding-left: 15px;
  }

  .booking-row {
    margin: 0;
  }
}

@media screen and (max-width: $ml-size) {
  .option-type-select {
    display: block;
  }

  .col-selected {
    padding-bottom: 8px;
  }

  .box-st-select {
    height: 53px;
    position: fixed;
    bottom: 0;
    right: 0;
    width: 100%;
    z-index: 99;
    background-color: $white;
    margin-bottom: 0px;
    border-top: 0.5px solid $light-gray-2;
  }

  .booking-total-sticky {
    display: grid;
    grid-template-columns: 65% auto;
    position: static;
    padding-left: 5%;
    padding-right: 5%;
  }

  .total-price {
    display: block;
    text-align: left;
    border: 0.5px solid $color-orange;
    border-radius: 5px;
    z-index: 999;
    padding-right: 0px;

    .left {
      display: none;
    }

    .right {
      padding-top: 4px;
    }
  }

  .sc-button {
    min-width: 0;
    font-size: $font-12;
  }

  .duplicate-check-box {
    text-align: left;
  }

  .price-mobile {
    display: block;
  }

  .price-desktop {
    display: none;
  }
}

@media screen and (max-width: $ss-size) {
  .booking-total-sticky {
    grid-template-columns: 60% auto;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/other-web/Conference/components/BookingBoxSelect.vue